import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';

const DeanProjectsStatusPage = () => {
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const navigate = useHistory();

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/departments`);
        setDepartments(response.data);
      } catch (error) {
        console.error('Error fetching departments:', error);
      }
    };
    fetchDepartments();
  }, []);
  
  const fetchProjects = async () => {
    if (!selectedDept || selectedStatus === '') return;
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects/statusfilterprojects`, {
        params: {
          deptId: selectedDept,
          status: selectedStatus,
          userId: sessionStorage.getItem('userId'),
        },
      });
      setProjects(response.data);
    } catch (err) {
      setError('Failed to fetch projects.');
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setSelectedDept('');
    setSelectedStatus('');
    setProjects([]);
  };

  return (
    <div className="container mt-4">
      {error && <div className="alert alert-danger text-center">{error}</div>}
      {loading && <div className="alert alert-info text-center">Loading projects...</div>}
      
      {/* Filters */}
      <div className="d-flex justify-content-center align-items-center mb-3">
        <div className="form-group me-2">
          <label className="form-label">Department:</label>
          <select
            className="form-select"
            value={selectedDept}
            onChange={(e) => setSelectedDept(e.target.value)}
          >
            <option value="">Select a Department</option>
            {departments.map((dept) => (
              <option key={dept.deptId} value={dept.deptId}>{dept.deptName}</option>
            ))}
          </select>
        </div>
        <div className="form-group me-2">
          <label className="form-label">Status:</label>
          <select
            className="form-select"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="">Select Status</option>
            {/*<option value="0">UnApproved</option>*/}
            <option value="1">Approved Level 1</option>
            {/*<option value="2">Archived</option>*/}
            <option value="3">Approved Level 2</option>
          </select>
        </div>
        <button 
  className="btn btn-primary btn-sm" 
  style={{ marginRight: '6px', padding: '4px 10px', fontSize: '14px', height: '30px' }} 
  onClick={fetchProjects}
>
  Filter
</button>
<button 
  className="btn btn-secondary btn-sm" 
  style={{ padding: '4px 10px', fontSize: '14px', height: '30px' }} 
  onClick={resetFilters}
>
  Reset
</button>


      </div>
      
      {/* Projects Table */}
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Project ID</th>
              <th>Project Title</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects.length > 0 ? (
              projects.map((project) => (
                <tr key={project.projId}>
                  <td>{project.projId}</td>
                  <td>{project.projTitle}</td>
                  <td>{project.projStartDate}</td>
                  <td>{project.projEndDate}</td>
                  <td>
                    <span className={`badge ${project.status === 0 ? 'bg-danger' : project.status === 1 ? 'bg-success' : project.status === 2 ? 'bg-warning' : 'bg-info'}`}>{
                      project.status === 0 ? 'UnApproved' :
                      project.status === 1 ? 'Approved Level 1' :
                      project.status === 2 ? 'Archived' :
                      'Approved Level 2'
                    }</span>
                  </td>
                  <td>
                    <button 
                      className="btn btn-primary btn-sm" 
                      onClick={() => navigate.push(`/viewProjdean/${project.projId}`)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">No projects found for the selected filters.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DeanProjectsStatusPage;